<template>
  <div class="page-shell">
    <EmptyState title="无权限" description="当前账号没有访问该页面的权限，请联系管理员授权后重试。" icon="el-icon-lock">
      <el-button type="primary" @click="$router.push('/')">返回工作台</el-button>
    </EmptyState>
  </div>
</template>
<script>
import EmptyState from '@/components/EmptyState.vue'
export default {
  name: 'Error403',
  components: { EmptyState }
}
</script>
